/**
 * Transform the date value and return a valid date object or undefined if parsing fails.
 * This can be used so we can invalidate wrong dates correctly.
 */
export function transformDate(value: string, originalValue: string) {
    const parsedDate = new Date(originalValue);

    return isNaN(parsedDate.getTime()) ? undefined : value;
}
